// Planification récurrente des cours : "Tous les [jours] à [heure]"
export const JOURS_SEMAINE = [
  { value: "lundi", label: "Lundi", court: "Lun" },
  { value: "mardi", label: "Mardi", court: "Mar" },
  { value: "mercredi", label: "Mercredi", court: "Mer" },
  { value: "jeudi", label: "Jeudi", court: "Jeu" },
  { value: "vendredi", label: "Vendredi", court: "Ven" },
  { value: "samedi", label: "Samedi", court: "Sam" },
  { value: "dimanche", label: "Dimanche", court: "Dim" },
];

// "18:00:00" -> "18h00"
export const formatHeure = (heure) => {
  if (!heure) return "";
  const [h, m] = heure.split(":");
  return `${h}h${m || "00"}`;
};

// { jours_semaine: ["lundi","mercredi"], heure_cours: "18:00:00" } -> "Lun, Mer · 18h00"
export const formatPlanification = (cours) => {
  const jours = Array.isArray(cours?.jours_semaine) ? cours.jours_semaine : [];
  const joursTxt = JOURS_SEMAINE.filter((j) => jours.includes(j.value)).map((j) => j.court).join(", ");
  const heureTxt = formatHeure(cours?.heure_cours);
  return [joursTxt, heureTxt].filter(Boolean).join(" · ");
};
